import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import plygonIcon from '../../../../assets/icons/plygon.svg'

import Card from '../Card'
import Openings from '../Openings'

class OpeningCard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    const { intl, classes, merchant } = this.props
    if (!merchant) return null
    const titleText = merchant.setting.defaultClientLanguage === 'en' ? 'Takeaway / Delivery Openings' : intl.formatMessage({ id: 'directory.opening.title' })
    const takeawaySubtitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Takeaway' : intl.formatMessage({ id: 'directory.opening.subtitle.takeaway' })
    const deliverySubtitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Delivery' : intl.formatMessage({ id: 'directory.opening.subtitle.delivery' })
    const takeawayOpenings = merchant && merchant.setting.directoryTakeawayTimeText
    const deliveryOpenings = merchant && merchant.setting.directoryDeliveryTimeText

    return (
      <Card>
        <div className={classes.spacing}>
          <p className={classes.title}>{titleText}</p>
        </div>
        <div className={classes.spacing}>
          {takeawayOpenings && (
            <div className={classes.info}>
              <div className={classes.icon}>
                <img src={plygonIcon} alt='plygon_icon'/>
              </div>
              <div className={classes.textContent}>
                <p>{takeawaySubtitleText}</p>
                <Openings type='takeaway' />
              </div>
            </div>
          )}
          {deliveryOpenings && (
            <div className={classes.info}>
              <div className={classes.icon}>
                <img src={plygonIcon} alt='plygon_icon'/>
              </div>
              <div className={classes.textContent}>
                <p>{deliverySubtitleText}</p>
                <Openings type='storeDelivery' />
              </div>
            </div>
          )}
        </div>
      </Card>
    )
  }
}

const styles = {
  spacing: {
    padding: 4,
  },
  title: {
    padding: 4,
    fontSize: 20,
  },
  info: {
    padding: 4,
    display: 'flex',
    '& p': {
      fontSize: 15,
      fontWeight: 300,
      lineHeight: '21px', // the height of the icon.
    },
  },
  icon: {
    flexShrink: 0,
    height: 21,
    width: 21,
    display: 'grid',
    placeItems: 'center',
    marginRight: 8,
  },
  gridContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    gridGap: '4px',
    '& > p': {
      whiteSpace: 'pre-line',
    },
  },
  gridItemFullwidth: {
    gridColumn: '1 / span 3',
  },
  openings: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(OpeningCard)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Card/OpeningCard.jsx